import React from 'react';
import { cn } from './Button';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'pink' | 'blue' | 'outline';
}
export function Badge({
  className,
  variant = 'default',
  ...props
}: BadgeProps) {
  const variants = {
    default: 'bg-slate-800 text-slate-300',
    pink: 'bg-[#EC4899] text-white',
    blue: 'bg-blue-500/20 text-blue-400 border border-blue-500/20',
    outline: 'border border-slate-700 text-slate-400'
  };
  return <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold transition-colors', variants[variant], className)} {...props} data-id="element-1052" />;
}